import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';

import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';
const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function(req) {
    req.on('response', function(res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getWebchatPreferenceStart() {
  return {
    type: types.GET_WEBCHAT_PREFERENCE_START,
  };
}

export function getWebchatPreferenceSuccess(webchatpreference) {
  return {
    type: types.GET_WEBCHAT_PREFERENCE_SUCCESS,
    webchatpreference,
  };
}

export function getWebchatPreferenceFail() {
  return {
    type: types.GET_WEBCHAT_PREFERENCE_FAIL,
  };
}

export function getWebchatPreference(business_id) {
  return (dispatch, getState) => {
    dispatch(getWebchatPreferenceStart());
    request
      .get(`${window.Config.API_URL}/business/preferences/webChat/preferences`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .ok((res) => res.status < 500)
      .then((resp) => {
        console.log('Preference---->', resp);
        if (resp.statusCode === 200) {
          dispatch(getWebchatPreferenceSuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getWebchatPreferenceFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getWebchatPreferenceFail());
      });
  };
}

export function postWebchatStatusStart() {
  return {
    type: types.POST_WEBCHAT_STATUS_START,
  };
}

export function postWebchatStatusSuccess(webchatstatus) {
  return {
    type: types.POST_WEBCHAT_STATUS_SUCCESS,
    webchatstatus,
  };
}

export function postWebchatStatusFail() {
  return {
    type: types.POST_WEBCHAT_STATUS_FAIL,
  };
}

export function postWebchatStatus(status, business_id, email) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        status: status,
        client_email: email,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatStatusStart());
    request
      .put(`${window.Config.API_URL}/business/preferences/webChat/status`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebchatStatusSuccess(status));
        } else {
          dispatch(postWebchatStatusFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatStatusFail());
      });
  };
}

export function postWebchatGreetingsStart() {
  return {
    type: types.POST_WEBCHAT_GREETING_START,
  };
}

export function postWebchatGreetingsSuccess(greeting) {
  return {
    type: types.POST_WEBCHAT_GREETING_SUCCESS,
    greeting,
  };
}

export function postWebchatGreetingsFail() {
  return {
    type: types.POST_WEBCHAT_GREETING_FAIL,
  };
}

export function postWebchatGreetings(
  greeting,
  firstmessage,
  business_id,
  email,
) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        greeting_message: greeting,
        first_message: firstmessage,
        client_email: email,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatGreetingsStart());
    request
      .put(
        `${window.Config.API_URL}/business/preferences/webChat/greetingPreference`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebchatGreetingsSuccess(params));
        } else {
          dispatch(postWebchatGreetingsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatGreetingsFail());
      });
  };
}

export function postWebchatBrandingSuccess(branding) {
  return {
    type: types.POST_WEBCHAT_BRAND_SUCCESS,
    branding,
  };
}

export function postWebchatBrandings(branding, business_id, email) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        business_name: branding.business_name,
        global_logo_file: branding.global_logo_file,
        file_name: branding.file_name,
        logo_file: branding.file_name,
        assistant_name: branding.assistant_name,
        action_color: branding.action_color,
        background_color: branding.background_color,
        client_email: email,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatGreetingsStart());
    request
      .put(
        `${window.Config.API_URL}/business/preferences/webChat/brandPersonalization`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebchatBrandingSuccess(branding));
        } else {
          dispatch(postWebchatGreetingsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatGreetingsFail());
      });
  };
}

export function postWebchatEmailPrefSuccess(emailpref) {
  return {
    type: types.POST_WEBCHAT_EMAILPREF_SUCCESS,
    emailpref,
  };
}

export function postWebchatEmailPrefs(emailpref, business_id, email) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        require_email: emailpref.require_email,
        email_capture_message: emailpref.email_capture_message,
        client_email: email,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatGreetingsStart());
    request
      .put(
        `${window.Config.API_URL}/business/preferences/webChat/newConversationPreference`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebchatEmailPrefSuccess(emailpref));
        } else {
          dispatch(postWebchatGreetingsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatGreetingsFail());
      });
  };
}

export function postWebchatCollapseSuccess(collapse) {
  return {
    type: types.POST_WEBCHAT_COLLAPSE_SUCCESS,
    collapse,
  };
}

export function postWebchatCollapses(collapse, business_id, email) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        collapse_on_start: collapse.collapse_on_start,
        client_email: email,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatGreetingsStart());
    request
      .put(
        `${window.Config.API_URL}/business/preferences/webChat/initialStatePreference`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebchatCollapseSuccess(collapse));
        } else {
          dispatch(postWebchatGreetingsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatGreetingsFail());
      });
  };
}
export function postWebchatEmailSuccess(email) {
  return {
    type: types.POST_WEBCHAT_EMAIL_SUCCESS,
    email,
  };
}
export function postWebchatEmailStart() {
  return {
    type: types.POST_WEBCHAT_EMAIL_START,
  };
}
export function postWebchatEmailFail() {
  return {
    type: types.POST_WEBCHAT_EMAIL_FAIL,
  };
}
export function postWebchatEmails(email, business_id, emailid) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        email_preference: email,
        client_email: emailid,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatEmailStart());
    request
      .put(`${window.Config.API_URL}/business/preferences/webChat/email`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postWebchatEmailSuccess(email));
        } else {
          dispatch(postWebchatEmailFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatEmailFail());
      });
  };
}
export function postWebchatLogoStart() {
  return {
    type: types.POST_WEBCHAT_LOGO_START,
  };
}

export function postWebchatLogoSuccess(logo) {
  return {
    type: types.POST_WEBCHAT_LOGO_SUCCESS,
    logo,
  };
}

export function postWebchatLogoFail() {
  return {
    type: types.POST_WEBCHAT_LOGO_FAIL,
  };
}

export function imageSizeissue() {
  return {
    type: types.POST_WEBCHAT_LOGO_SIZE_ISSUE,
  };
}

export function postWebchatLogo(file, business_id, email) {
  return (dispatch, getState) => {
    var formData = new FormData();
    formData.append('client_email', email);
    formData.append('image', file);
    const { auth } = getState();
    dispatch(postWebchatGreetingsStart());
    request
      .put(`${window.Config.API_URL}/business/preferences/webChat/logo`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(formData)
      .ok((res) => res.status < 500)
      .then((resp) => {
        console.log('Preference---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebchatLogoSuccess(resp.body));
        } else {
          dispatch(imageSizeissue());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatLogoFail());
      });
  };
}
